import { useRef } from "react"

import Style from "./style"

import usePutAccountSeedTicketCollect from "entity/account/useDeleteAccountSeedTicket"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"

const CollectModal = ({ ticketTypeIdx, closeEvent }) => {
    const numberRef = useRef()

    const [collectTicket] = usePutAccountSeedTicketCollect(ticketTypeIdx, numberRef)

    return (
        <DefaultModal title="시드권 회수" closeEvent={closeEvent}>
            <Style.Wrapper>
                <input placeholder="개수 입력" ref={numberRef} />
                <DefaultButton small fitWidth clickEvent={collectTicket}>회수</DefaultButton>
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default CollectModal